__turbopack_context__.v({
  "disabled": "Button-module-scss-module__ddChZW__disabled",
  "link": "Button-module-scss-module__ddChZW__link",
  "loading": "Button-module-scss-module__ddChZW__loading",
  "primary": "Button-module-scss-module__ddChZW__primary",
  "quickAdd": "Button-module-scss-module__ddChZW__quickAdd",
  "root": "Button-module-scss-module__ddChZW__root",
  "secondary": "Button-module-scss-module__ddChZW__secondary",
  "slim": "Button-module-scss-module__ddChZW__slim",
});
